export const notifText = (kind) => ({
  reply: "replied to your comment",
  resolved: "resolved your comment",
  mention: "mentioned you",
  accepted: "accepted your suggestion",
  rejected: "rejected your suggestion",
}[kind] || "updated a comment");
